import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetDipRecordComposersDocument,
  type GetDipRecordComposersQuery,
  type GetDipRecordComposersQueryVariables,
} from "~/features/dataImportProjects/gqls";

/** Read-only DIP record composers (with their evidence sets). */
export function useDipRecordComposers(dataImportProjectId: string) {
  return useSuspenseQuery<GetDipRecordComposersQuery, GetDipRecordComposersQueryVariables>(
    GetDipRecordComposersDocument,
    {
      variables: { dataImportProjectId },
    },
  );
}
